import type { FormFieldVariant } from './formField.types';

export const DEFAULT_FORM_FIELD_VARIANT: FormFieldVariant = 'floating';
